<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <section
      v-scroll-lock="true"
      class="modal active"
    >
      <div class="modal-overlay" />

      <section class="modal-container modal-form modal-form--lg form-new-card">
        <header class="modal-header modal-form__header">
          <a
            class="btn btn-clear float-right modal-form__close"
            aria-label="close"
            @click="close"
          />

          <h1 class="modal-form__title mb-0">
            Gerenciar meus cartões
          </h1>
        </header>

        <article class="modal-body modal-form__body mt-0 pt-0">
          <div
            :class="{ 'cursor-not-allowed': ui.isLoading }"
            class="form-new-card__wrapper"
          >
            <credit-card-list
              v-model="card"
              :ref="'cardList'"
              :class="{ 'pointer-events-none': ui.isLoading }"
              @update="updateCard"
            />
          </div>
        </article>

        <footer class="modal-form__footer flex flex-row items-center justify-end mb-0 px-2">
          <button
            :disabled="!isValid || ui.isLoading"
            class="btn btn-primary"
            @click="setDefault"
          >
            Tornar cartão padrão
          </button>
        </footer>
      </section>
    </section>
  </transition>
</template>

<script>
import creditCardList from './creditCardList'

export default {
  name: 'ListCreditCardModal',

  components: {
    creditCardList
  },

  data () {
    return {
      card: {},
      ui: {
        isLoading: false
      }
    }
  },

  computed: {
    isValid () {
      return 'isDefault' in this.card
        ? !this.card.isDefault
        : false
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    setDefault () {
      const url = `/user/credit_card/${this.card.id}/set_default`

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .put(url, { 'is_default': true }, this.$store.getters.getAuthHeader)
        .then(() => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Cartão definido como padrão com sucesso.',
            size: 'md',
            active: true
          })

          this.$refs['cardList'].getCards()
          this.$emit('update')
        })
        .catch((err) => this.fn_HANDLE_ERROR(err))
        .finally(() => {
          this.ui.isLoading = false
          this.fn_HIDE_PROGRESS()
        })
    },

    updateCard () {
      this.$nextTick(() => this.$emit('update'))
    }
  }
}
</script>

<style lang="scss" scoped>
.form-new-card {
  width: 40rem;

  &__wrapper {
    @apply p-3 rounded rounded-lg;
    background: #f4f4f4;
  }
}
</style>
